import React from 'react'
import Archive from './Archive.jsx'

require('../css/archives.css')

const SeeMore = (props) => {
  return <li onClick={props.action} className='video-list-see-more'>More</li>
}

export default class ArchiveList extends React.Component {
  constructor(props){
    super(props)
    this.state = {videoLimit: props.videoLimit || 7}
    this.videosToRender = []
    this.setVideoLimit = this.setVideoLimit.bind(this)
    this.filterVideos = this.filterVideos.bind(this)
    this.renderVideos = this.renderVideos.bind(this)
  }
  setVideoLimit() {
    this.setState({videoLimit: this.state.videoLimit + 6})
  }
  filterVideos(video){
    var textFiltered = 0
    var categoryFiltered = 1
    if(this.props.category && this.props.category != 'all'){
      if (parseInt(video.category) != this.props.category) categoryFiltered = 0
    }
    if(video.custom_name){
      if (video.custom_name.toLowerCase().indexOf(this.props.filterText.toLowerCase()) != -1) textFiltered = 1
    }
    if(video.date.toLowerCase().indexOf(this.props.filterText.toLowerCase()) != -1) textFiltered = 1
    if(textFiltered === 1 && categoryFiltered === 1){
      return true
    }
    return false
  }
  renderVideos(video){
    return <Archive key={video.idHash} external={this.props.external} video={video}></Archive>
  }
  render(){
    var videoLimit = this.state.videoLimit
    var videosToRender = this.props.videos.filter(this.filterVideos).map(this.renderVideos)
    var videos = videosToRender.slice(0, videoLimit)
    var totalVideoLength = videosToRender.length
    var seeMore = null
    if(videoLimit < totalVideoLength){
      seeMore = <SeeMore action={this.setVideoLimit}/>
    }
    return (<ul id='streamspot-video-list' className="video-list">{videos}{seeMore}</ul>)
  }
}

ArchiveList.propTypes =  {
  videos: React.PropTypes.array.isRequired,
  external: React.PropTypes.bool.isRequired
}



// WEBPACK FOOTER //
// ./src/components/ArchiveList.jsx